//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppHeader from "~/components/AppHeader.vue";
import BottomNavigation from '~/components/BottomNavigation.vue';
import WebSisteBottomNavigation from "~/components/WebSisteBottomNavigation.vue";
import AppFooter from "~/components/AppFooter.vue";
import TopBar from "~/components/TopBar.vue";
import CartSidebar from "~/components/CartSidebar.vue";
import WishlistSidebar from "~/components/WishlistSidebar.vue";
import LoginModal from "~/components/LoginModal.vue";
import LazyHydrate from "vue-lazy-hydration";
import Notification from "~/components/Notification";
import { onSSR } from "@vue-storefront/core";
import { useRoute, watch, useRouter, onMounted, computed, ref, onUnmounted, onBeforeUnmount } from "@nuxtjs/composition-api";
import BottomCookie from "~/components/Bottom/CookieModal";
import floatButtons from "~/components/floatButtons.vue";

import {
  useUser,
  useOCart,
  useStore,
  useWishlist,
  useApiError,
  useOauth,
  useGuest,
  usePrePayList,
  useCredential
} from "@bee-hole/coms";
import { useUiNotification, useUiState } from "~/composables";
import { useCustomerStore } from '~/stores/customer';
import { usePreviewOrderStore } from '~/stores/previewOrder';
export default {
  name: "website",
  components: {
    LazyHydrate,
    TopBar,
    AppHeader,
    WebSisteBottomNavigation,
    BottomNavigation,
    AppFooter,
    CartSidebar,
    WishlistSidebar,
    LoginModal,
    Notification,
    BottomCookie,
    floatButtons
  },
  head() {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true });
    const meta = this?.configs?.meta || [];
    const link = this?.configs?.link || [];
    let cssText = '';
    // 判断背景颜色是否为白色 包括fff大小写
    if (this.bgColor && (this.bgColor.toLowerCase().indexOf('fff') === -1 && this.bgColor.toLowerCase() !== 'white')) {
      cssText += "--c-primary:" + this.bgColor + ';';
    }
    if (this.fontColor) {
      cssText += ("--web-font-color:" + this.fontColor + ';');
      cssText += ("--c-text:" + this.fontColor + ';');
      cssText += ("--heading-description-color:" + this.fontColor + ';');
      cssText += ("--input-label-color:" + this.fontColor + ';');
      cssText += ("--textarea-label-color:" + this.fontColor + ';');
      cssText += ("--textarea-bg-color:" + this.fontColor + ';');
    } else {
      cssText += ("--web-font-color:" + '#1a1a1a' + ';');
    }
    if (this?.configs?.TopBar?.color) {
      cssText += ("--top-bar-background:" + this?.configs?.TopBar?.color + ';');
    }
    const mates = [];
    if (meta?.length) {
      meta.map(mitem => {
        if (mitem.name) {
          mates.push({
            name: mitem.name,
            content: mitem.content
          });
        } else {
          mates.push({
            charset: mitem.charset
          });
        }
      });
    }
    return {
      htmlAttrs: {
        myAttribute: this?.configs?.title,
        ...i18nHead.htmlAttrs
      },
      title: this?.configs?.title,
      meta: [...mates, ...i18nHead.meta],
      link: [...link, ...i18nHead.link],
      style: [{
        cssText: '#webSite {' + cssText + '}'
      }]
    };
  },
  setup(p, context) {
    const { root: { $nuxt, $cookies, $i18n, $options: { $xreq } }, root } = context;
    $i18n.__baseUrl = 'https://' + $xreq.host;
    const webSite = ref();
    // 获取消息通知弹窗Id
    const notificationId = ref();
    const route = useRoute();
    // const { relationAdd, result: relationRes } = useRelation();
    const { getPinJu, result: pingju } = useCredential();
    const { isLoginModalOpen, toggleLoginModal, resize } = useUiState();
    const { load: loadStores } = useStore();
    const { load: loadUser, isAuthenticated } = useUser();
    const { refreshToken } = useOauth();
    const { load: loadCart } = useOCart();
    const { load: loadWishlist } = useWishlist();
    const previewOrderStore = usePreviewOrderStore();
    const { error } = useApiError();
    const router = useRouter();
    const notify = useUiNotification();
    const { setToken, getToken, guestLogin, guest } = useGuest();
    const customerStore = useCustomerStore();
    const PreTime = ref();
    const timeoutId = ref();
    const { getPrePayList, prepaylist } = usePrePayList('prePayList');
    const isGuest = computed(() => {
      return context?.root?.$options?.$mallConfig?.mall_web_config?.is_guest;
    });
    const headerList = computed(() => {
      return context?.root?.$options?.$mallConfig?.mall_web_config?.headeTop || [];
    });
    const BgImg = computed(() => {
      const config = context?.root?.$options?.$mallConfig?.mall_home_artice;
      return `url(${config?.bgImg || ''})`;
    });
    const BgVideo = computed(() => {
      const config = context?.root?.$options?.$mallConfig?.mall_home_artice;
      return config?.bgVideo || '';
    });
    // const { configList, configs } = useConfig("mall_web_config");
    const configs = computed(() => context?.root?.$options?.$mallConfig?.mall_web_config);
    const bgColor = computed(() => {
      const config = context?.root?.$options?.$mallConfig?.mall_home_artice;
      return config?.bgColor || '#09194c';
    });
    const fontColor = computed(() => {
      const config = context?.root?.$options?.$mallConfig?.mall_home_artice;
      return config?.fontColor || '#ffffff';
    });
    const getPrePayOrder = async () => {
      if (PreTime.value) {
        clearTimeout(PreTime.value);
      }
      await getPrePayList({ user_id: $cookies.get('userKey'), from_id: $cookies.get('tokenkey') });
      if (prepaylist.value?.list?.length) {
        PreTime.value && clearTimeout(PreTime.value);
        console.log('prelist', prepaylist.value);
        await getPinJu({ prepay_id: prepaylist.value?.list[0]?.prepay_id });
        if (pingju.value?.credential_id) {
          router.push(root.localePath('/xpay?orderNumber=' + prepaylist.value?.list[0]?.prepay_id + "&credential_id=" + pingju.value?.credential_id));
        }
      } else {
        PreTime.value = setTimeout(() => {
          getPrePayOrder();
        }, 1000);
      }
    };
    const getCart = async () => {
      if (PreTime.value) {
        clearTimeout(PreTime.value);
      }
      const cartData = await context.root.$vsf.$xbuy.api.customCartLoad({});
      const setType = cartData?.data?.setType;
      if (String(setType) === '1') {
        // PreTime.value && clearTimeout(PreTime.value);
        loadCart();
        router.push(root.localePath('/checkout/shipping'));
      }
      PreTime.value = setTimeout(() => {
        getCart();
      }, 1000);
    };
    const shouyinLoad = () => {
      if (customerStore?.settlement === 1) {
        getCart();
      } else if (customerStore?.settlement === 2) {
        getPrePayOrder();
      }
    };
    onBeforeUnmount(() => {
      if (PreTime.value) {
        clearTimeout(PreTime.value);
        customerStore.setIsGoPay(false);
      }
      if (process.client) {
        // 清除 resize 事件处理器
        window.onresize = null;
        if (timeoutId.value !== null) {
          // 清理定时器
          clearTimeout(timeoutId.value);
        }
      }
    });
    onUnmounted(() => {
      if (PreTime.value) {
        console.log('web卸载轮询');
        clearTimeout(PreTime.value);
        customerStore.setIsGoPay(false);
      }
    });
    const authenticatedFcn = async () => {
      if (isAuthenticated.value) {
        await loadUser();
        if (route.value?.path?.indexOf('/checkout') === -1) {
          await loadCart();
          await loadWishlist();
        }
      }  else {
        // const distcode = route.value.query.distributor_code;
        // if (distcode) {
        //   await relationAdd({ distributor_code: distcode });
        // }
      }
    };
    onMounted(async () => {
      if (process.client) {
        window.onresize = resize;
        timeoutId.value = setTimeout(() => {
          resize();
        }, 100);
      }
      if (route.value?.query?.settlement) {
        customerStore.setSettlement(Number(route.value?.query?.settlement));
      }
      if (route.value?.query?.tokenkey) {
        $cookies.set("tokenkey", route.value?.query?.tokenkey, {
          path: "/",
          sameSite: "Lax",
          maxAge: 3600 * 24 * 31
        });
        if (route.value?.query?.suiji) {
          previewOrderStore.reset();
          $cookies.remove('token');
          await getToken({ key: route.value?.query?.tokenkey });
          // customerStore.setToken(guest.value?.token);
          await loadUser();
          customerStore.setisSetToken(true);
        } else {
          customerStore.setisSetToken(false);
          customerStore.setIsGoPay(false);
        }
        if (!$cookies.get("token")) {
          toggleLoginModal();
        }
        if (!customerStore?.isGoPay) {
          shouyinLoad();
          customerStore.setIsGoPay(true);
        }
      }
      if (route.value?.query?.userKey) {
        $cookies.set("userKey", route.value?.query?.userKey, {
          path: "/",
          sameSite: "Lax",
          maxAge: 3600 * 24 * 1
        });
      }
      if (route.value?.query?.token) {
        $cookies.set("token", route.value?.query?.token, {
          path: "/",
          sameSite: "Lax",
          maxAge: 3600 * 24 * 365
        });
        await refreshToken();
        router.push(root._route.path);
        await loadUser();
        loadCart();
        loadWishlist();
      }

      if (route.value?.query?.path) {
        customerStore.setLoginPath(route.value?.query?.path);
      }
      const newtoken = $cookies.get("token");
      const tokenkey = $cookies.get("tokenkey");
      if ((!customerStore?.isGoPay || !PreTime.value) && tokenkey) {
        shouyinLoad();
        customerStore.setIsGoPay(true);
      }
      if (tokenkey && !customerStore?.isSetToken && newtoken) {
        await setToken({ key: tokenkey });
        customerStore.setisSetToken(true);
        if (!PreTime.value) {
          shouyinLoad();
          customerStore.setIsGoPay(true);
        }
      }
      if (route.value?.query?.path === 'Shipping') {
        router.push(context.root.localePath('/my-account/Shipping'));
      } else if (route.value?.query?.path === 'order') {
        router.push(context.root.localePath('/checkout/shipping'));
      }
      authenticatedFcn();
      // if (!isAuthenticated.value) {
      //   await loadUser();
      //   if (route.value?.path?.indexOf('/checkout') === -1) {
      //     await loadCart();
      //     await loadWishlist();
      //   }
      // }
      // webSite.value?.style?.setProperty("--c-primary", bgColor.value);
      // if (fontColor.value) {
      //   webSite.value?.style?.setProperty("--web-font-color", fontColor.value);
      //   webSite.value?.style?.setProperty("--c-text", fontColor.value);
      //   webSite.value?.style?.setProperty("--heading-description-color", fontColor.value);
      //   webSite.value?.style?.setProperty("--input-label-color", fontColor.value);
      //   webSite.value?.style?.setProperty("--textarea-label-color", fontColor.value);
      //   webSite.value?.style?.setProperty("--textarea-bg-color", bgColor.value);
      // } else {
      //   webSite.value?.style?.setProperty("--web-font-color", '#1a1a1a');
      // }
      // webSite.value?.style?.setProperty("--header-background", bgColor.value);
    });
    const handleActionClick = () => {
      notify.dismiss(notificationId.value);
      router.push(context.root.localePath('/my-account/History?open=2'));
    };
    watch(error, async () => {
      if (error.value.code === 61) {
        if (!isLoginModalOpen.value) {
          toggleLoginModal();
        }
      } else {
        if (error.value.code === 2201) {
          return false;
        }
        let action = {};
        if (error.value.code === 3208 || error.value.code === 3128) {
          action = {
            text: $nuxt.$t('go_to_see_prepid'),
            onClick: handleActionClick
          };
        }
        notificationId.value = notify.send({
          type: error.value.code === 0 ? "success" : "danger",
          message: (error.value.code !== 0 ? (error.value.code + ': ') : '') + String($nuxt.$t(error.value.message)),
          time: error.value.time || 0,
          action
        });
      }
    });
    onSSR(async (ctx) => {
      if (route.value.query.ref) {
        $cookies.set("distributor_code", route.value.query.ref, {
          path: "/",
          sameSite: "Lax",
          maxAge: 3600 * 24 * 31
        });
      }
      if (ctx?.$root?.$options?.$xreq?.host) {
        ctx.$root.$i18n.__baseUrl = 'https://' + ctx.$root.$options.$xreq.host;
      }
      await Promise.all([
        loadStores(),
        loadUser()
      ]);
    });

    return {
      route,
      configs,
      bgColor,
      webSite,
      BgImg,
      fontColor,
      BgVideo,
      headerList
    };
  }
};
